/**
 * Gated by `isDALAvailable()` (endpoint configured) rather than the live per-user toggle, so
 * failures are still observable if support disables the toggle mid-incident.
 */

import { CILogger } from 'common/log/log.provider';

import { isDALAvailable } from './config';

const PREFIX = '[DAL]';

export const dalLogger = {
    info(message: string, ...rest: unknown[]): void {
        if (!isDALAvailable()) {
            return;
        }
        CILogger.getInstance().info(PREFIX, message, ...rest);
    },
    warn(message: string, ...rest: unknown[]): void {
        if (!isDALAvailable()) {
            return;
        }
        CILogger.getInstance().warn(PREFIX, message, ...rest);
    },
    error(message: string, ...rest: unknown[]): void {
        if (!isDALAvailable()) {
            return;
        }
        CILogger.getInstance().error(PREFIX, message, ...rest);
    },
};
